import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  IconButton,
  Checkbox,
  ListItemText,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import {
  material_request,
  vendor_material_enquriylist,
  vendor_material_list,
  delete_vendor_material,
} from "../../../api/ControllApi";
import { get_vendor_store } from "../../../api/Role";
import { useUser } from "../../../context/LoginDetail";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";


export default function AddMaterialForm() {
  const [materials, setMaterials] = useState([]);
  const [selectedBrandId, setSelectedBrandId] = useState([]); // Change to array
  const [materialList, setMaterialList] = useState([]);
  const [selectedMaterialId, setSelectedMaterialId] = useState("");
  const [brandList, setBrandList] = useState([]);
const [tableLoading, setTableLoading] = useState(false);
const PLACEHOLDER_IMG =
  "https://via.placeholder.com/50x50?text=No+Image";
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user } = useUser();
  const navigate = useNavigate();
  const [hasCompany, setHasCompany] = useState(false);
  const [checkLoading, setCheckLoading] = useState(true);
  
  // Deletion Dialog State
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
//   

  const getEnquiryList = async () => {
    setTableLoading(true);
    try {
      const res = await vendor_material_enquriylist();
      setMaterials(res?.data || []);
    } catch (err) {

      setMaterials([]);
    } finally {
      setTableLoading(false);
    }
  };

  const checkCompanyProfile = async () => {
    if (!user?.id) return;
    setCheckLoading(true);
    try {
      const res = await get_vendor_store(user.id);
      if (res?.data) {
        setHasCompany(true);
      } else {
        setHasCompany(false);
      }
    } catch (err) {

      setHasCompany(false);
    } finally {
      setCheckLoading(false);
    }
  };

  useEffect(() => {
    if (user?.id) {
      checkCompanyProfile();
    }
  }, [user?.id]);

  

  useEffect(() => {
    getEnquiryList();
  }, []);
  const getDropdownMaterialList = async () => {
    setLoading(true);
    try {
      const res = await vendor_material_list();
      setMaterialList(res?.data?.material || []);
    } catch (err) {

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDropdownMaterialList();
  }, []);

  const handleMaterialChange = (e) => {
    const materialId = e.target.value;
    setSelectedMaterialId(materialId);
    setSelectedBrandId([]); // Reset to empty array
    
    // Find the selected material to get its specific brands
    const material = materialList.find((m) => m.id === materialId);
    setBrandList(material?.brand || []);
  };

   

  /* SUBMIT */
/* SUBMIT */
const handleQuery = async () => {
  // REMOVED: selectedBrandId.length === 0 check
  if (!selectedMaterialId) {
    toast.error("Please select a material");
    return;
  }
  
  setLoading(true);
  try { 
    const res = await material_request({
      material_id: Number(selectedMaterialId),
      // This sends the array directly, e.g., [7, 4, 3, 7]
      // If none selected, it sends []
      brand_id: selectedBrandId, 
    });

    if (res?.status === 200) {
      toast.success("Material added successfully");
      setSelectedMaterialId("");
      setSelectedBrandId([]);
      setOpen(false);
      getEnquiryList();
    }
  } catch (error) {

    if (error?.response?.status === 409) {
      toast.error("Material already exists");
    } else {
      toast.error(error?.response?.data?.message || "API Error");
    }
  } finally {
    setLoading(false);
  }
};

const handleDelete = (id) => {
  setItemToDelete(id);
  setDeleteDialogOpen(true);
};

const confirmDelete = async () => {
  if (!itemToDelete) return;
  
  setDeleteLoading(true);
  try {
    const res = await delete_vendor_material(itemToDelete);
    if (res?.status === 200) {
      toast.success("Material deleted successfully");
      getEnquiryList();
    }
  } catch (err) {

    toast.error("Delete failed");
  } finally {
    setDeleteLoading(false);
    setDeleteDialogOpen(false);
    setItemToDelete(null);
  }
};


  if (checkLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
        <CircularProgress sx={{ color: "#7E9F40" }} />
      </Box>
    );
  }

  if (!hasCompany) {
    return (
      <Box sx={{ p: { xs: 1.5, sm: 3 }, textAlign: "center", mt: 5 }}>
        <Typography variant="h6" gutterBottom>
          Please complete your Company Profile to add materials.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate("/dashboard/company-profile")}
          sx={{ bgcolor: "#7E9F40", mt: 2, textTransform: "none" }}
        >
          Go to Company Profile
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 1.5, sm: 3 } }}>
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h6">Add Material List</Typography>

        <Button
          variant="contained"
          onClick={() => setOpen(true)}
          sx={{ bgcolor: "#7E9F40", textTransform: "none" }}
        >
          Add Material
        </Button>
      </Box>

      {/* TABLE */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ bgcolor: "#F5F5F5" }}>
            <TableRow>
              <TableCell><b>Material Name</b></TableCell>
              <TableCell><b>Brand Name</b></TableCell>
              <TableCell><b>Image</b></TableCell>
              <TableCell align="right"><b>Action</b></TableCell>
            </TableRow>
          </TableHead>
  <TableBody>
  {tableLoading && (
    <TableRow>
      <TableCell colSpan={4} align="center">
        Loading...
      </TableCell>
    </TableRow>
  )}

  {!tableLoading && materials.length > 0 &&
    materials.map((item) => (
      <TableRow key={item.id}>
        <TableCell>
          {item?.material?.material_name || "-"}
        </TableCell>
<TableCell>
  {Array.isArray(item?.material?.brand) && item.material.brand.length > 0
    ? item.material.brand.map((b) => b.name).join(", ")
    : "No brand"}
</TableCell>

        <TableCell>
          <img
            src={item?.material?.image?.[0] || PLACEHOLDER_IMG}
            alt={item?.material?.material_name || "material"}
            width={50}
            height={50}
            style={{ borderRadius: 6, objectFit: "cover" }}
            onError={(e) => {
              e.target.src = PLACEHOLDER_IMG;
            }}
          />
        </TableCell>

        <TableCell align="right">
          <IconButton onClick={() => handleDelete(item.id)} color="error" size="small">
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    ))}

  {!tableLoading && materials.length === 0 && (
    <TableRow>
      <TableCell colSpan={4} align="center">
        No Material Found
      </TableCell>
    </TableRow>
  )}
</TableBody>


        </Table>
      </TableContainer>

      {/* POPUP */}
      <Dialog open={open} fullWidth maxWidth="xs">
        <DialogTitle>
          Add Material
          <IconButton
            onClick={() => setOpen(false)}
            sx={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <Select
              fullWidth
              value={selectedMaterialId}
              displayEmpty
              onChange={handleMaterialChange}
            >
              <MenuItem value="">
                <em>Select Material</em>
              </MenuItem>

              {materialList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.material_name}
                </MenuItem>
              ))}
            </Select>
<Select
  fullWidth
  multiple
  value={selectedBrandId}
  displayEmpty
  onChange={(e) => setSelectedBrandId(e.target.value)}
  renderValue={(selected) => {
    // If array is empty, show the placeholder instead of a blank space
    if (selected.length === 0) {
      return <em>Select Brands (Optional)</em>;
    }
    return brandList
      .filter((b) => selected.includes(b.id))
      .map((b) => b.name)
      .join(", ");
  }}
>
              <MenuItem disabled value="">
                <em>Select Brands</em>
              </MenuItem>

              {brandList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  <Checkbox checked={selectedBrandId.indexOf(item.id) > -1} />
                  <ListItemText primary={item.name} />
                </MenuItem>
              ))}
            </Select>

            <Button
              variant="contained"
              onClick={handleQuery}
              disabled={loading}
              sx={{
                bgcolor: "#7E9F40",
                textTransform: "none",
              }}
            >
              {loading ? "Submitting..." : "Submit"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      {/* DELETION CONFIRMATION DIALOG */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => !deleteLoading && setDeleteDialogOpen(false)}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        centered
      >
        <DialogTitle id="delete-dialog-title">
          {"Confirm Delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete this material? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 3 }}>
          <Button 
            onClick={() => setDeleteDialogOpen(false)} 
            disabled={deleteLoading}
            sx={{ textTransform: "none", color: "grey.600" }}
          >
            Cancel
          </Button>
          <Button 
            onClick={confirmDelete} 
            disabled={deleteLoading}
            variant="contained"
            color="error"
            autoFocus
            sx={{ textTransform: "none" }}
          >
            {deleteLoading ? "Deleting..." : "Yes, Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
